import React from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { Card } from 'transfix-ui'
import { DISPLAY } from 'constants/display'

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: 10,
  },
  infoContainer: {
    display: 'grid',
    gridTemplateColumns: '200px auto',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  bold: {
    fontWeight: 'bold',
  },
  label: {
    width: 200,
    color: brandColors.coolGray5,
  },
}))

export interface ITrailerDetailsCardProps {
  carrier?: string
  equipmentType?: string
  size?: string
  title?: string
}

const TrailerDetailsCard = ({
  carrier = DISPLAY.empty,
  equipmentType = DISPLAY.empty,
  size = DISPLAY.empty,
  title = 'Trailer Details',
}: ITrailerDetailsCardProps) => {
  const classes = useStyles()

  return (
    <Card className={classes.card} title={title}>
      <Box display='flex' flexDirection='column'>
        <Box className={classes.infoContainer}>
          <Typography variant='subtitle2' color='textSecondary'>
            Carrier
          </Typography>
          <Typography variant='body2'>{carrier}</Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Typography variant='subtitle2' color='textSecondary'>
            Equipment Type
          </Typography>
          <Typography variant='body2'>{equipmentType}</Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Typography variant='subtitle2' color='textSecondary'>
            Size
          </Typography>
          <Typography variant='body2'>{size}</Typography>
        </Box>
      </Box>
    </Card>
  )
}

export default TrailerDetailsCard
